import * as React from "react";

import { Link } from "react-router-dom";

import Button from "../../Components/Button";

import Logo from "../../Images/logo.png";

import "./EditedPassword.scss";

const EditedPassword = () => {
  return (
    <div className="edited-password">
      <div className="logo">
        <img src={Logo} alt="" />
      </div>
      <div className="content-form">
        <h1>Mot de passe mis à jour</h1>
        <p>Votre mot de passe a été modifié avec succès</p>

        <div className="wrap_actions_form">
          <Link to="/login">
            <Button type="button" size="lg">
              Se connecter
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default EditedPassword;
